import { useContext } from 'react'
import { PerformAssessmentContext } from '../PerformAssessmentContext'
import { screen_2_letter_nonsense_words_demo_male, screen_2_letter_nonsense_words_demo_female, screen_2_multiple_choice_questions_demo_female, screen_2_multiple_choice_questions_demo_male, screen_2_letter_vowel_clusters_demo_female, screen_2_letter_vowel_clusters_demo_male, screen_2_letter_naming_demo_female, screen_2_letter_naming_demo_male, screen_2_letter_sounds_demo_female, screen_2_letter_sounds_demo_male, screen_2_word_list_demo_female, screen_2_word_list_demo_male, screen_2_vowel_sound_demo_female, screen_2_vowel_sound_demo_male } from 'introductions'
import { _screen_2_word_list_no_nikud_demo_female, _screen_2_multiple_choice_questions_demo_female, _screen_2_multiple_choice_questions_demo_male, _screen_2_word_list_no_nikud_demo_male } from 'introductions/highGrades'
import categories from 'keys/categories'
import multipleChoiceQuestions from '../multipleChoiceQuestions'

const Step2 = () => {
    const { isMaleGender, isHighGrade } = useContext(PerformAssessmentContext)

    const stepData = {
        ["default"]: {
            assessmentId: null
        },
        [categories.LETTER_NAMING]: {
            record: isMaleGender ? screen_2_letter_naming_demo_male : screen_2_letter_naming_demo_female,
            assessmentId: 84,
            changeBoldWordAfterSeconds: isMaleGender ? 1000 : 850,
            boldWordAfterSeconds: isMaleGender ? 7500 : 8700
        },
        [categories.FINAL_LETTERS]: {
            record: isMaleGender ? screen_2_letter_naming_demo_male : screen_2_letter_naming_demo_female,
            assessmentId: 84,
            changeBoldWordAfterSeconds: isMaleGender ? 1000 : 850,
            boldWordAfterSeconds: isMaleGender ? 7500 : 8700
        },
        [categories.NONSENSE_WORDS]: {
            record: isMaleGender ? screen_2_letter_nonsense_words_demo_male : screen_2_letter_nonsense_words_demo_female,
            assessmentId: 194,
            changeBoldWordAfterSeconds: isMaleGender ? 1200 : 1200,
            boldWordAfterSeconds: isMaleGender ? 9200 : 9200
        },
        // [categories.INFORMATIONAL_TEXT]: {
        //     record: isMaleGender ? screen_2_word_list_demo_male : screen_2_word_list_demo_female,
        //     assessmentId: 40,
        //     changeBoldWordAfterSeconds: isMaleGender ? 1000 : 1000,
        //     boldWordAfterSeconds: isMaleGender ? 7000 : 6000
        // },
        [categories.REAL_WORDS]: {
            record: isMaleGender ? screen_2_word_list_demo_male : screen_2_word_list_demo_female,
            assessmentId: 40,
            changeBoldWordAfterSeconds: isMaleGender ? 1000 : 860,
            boldWordAfterSeconds: isMaleGender ? 7000 : 9400
        },
        [categories.REAL_WORDS_NO_NIKUD]: {
            record:
                isHighGrade ?
                    (isMaleGender ? _screen_2_word_list_no_nikud_demo_male : _screen_2_word_list_no_nikud_demo_female) :
                    (isMaleGender ? screen_2_word_list_demo_male : screen_2_word_list_demo_female),
            assessmentId:
                isHighGrade ? 254 : 40,
            changeBoldWordAfterSeconds:
                isHighGrade ?
                    (isMaleGender ? 1100 : 1150) :
                    (isMaleGender ? 1000 : 860),
            boldWordAfterSeconds:
                isHighGrade ?
                    (isMaleGender ? 4800 : 5050) :
                    (isMaleGender ? 7000 : 9400)

        },
        [categories.LETTER_SOUNDS]: {
            record: isMaleGender ? screen_2_letter_sounds_demo_male : screen_2_letter_sounds_demo_female,
            assessmentId: 79,
            changeBoldWordAfterSeconds: isMaleGender ? 1000 : 950,
            boldWordAfterSeconds: isMaleGender ? 4800 : 5500
        },
        [categories.VOWEL_SOUND]: {
            record: isMaleGender ? screen_2_vowel_sound_demo_male : screen_2_vowel_sound_demo_female,
            assessmentId: isMaleGender ? 88 : 81,
            changeBoldWordAfterSeconds: isMaleGender ? 750 : 600,
            boldWordAfterSeconds: isMaleGender ? 7200 : 7200
        },
        [categories.LETTER_VOWEL_CLUSTERS]: {
            record: isMaleGender ? screen_2_letter_vowel_clusters_demo_male : screen_2_letter_vowel_clusters_demo_female,
            assessmentId: 67,
            changeBoldWordAfterSeconds: isMaleGender ? 880 : 880,
            boldWordAfterSeconds: isMaleGender ? 8800 : 9800
        },
        [categories.MULTIPLE_CHOICE_QUESTIONS]: {
            record:
                isHighGrade ?
                    (isMaleGender ? _screen_2_multiple_choice_questions_demo_male : _screen_2_multiple_choice_questions_demo_female) :
                    (isMaleGender ? screen_2_multiple_choice_questions_demo_male : screen_2_multiple_choice_questions_demo_female),
            assessmentId: null,
            skipNextStep: true,
            data: multipleChoiceQuestions,
            boldWordAfterSeconds:
                isHighGrade ?
                    (isMaleGender ? 5500 : 4500) :
                    (isMaleGender ? 7500 : 8500)
        }
    }

    return stepData

}

export default Step2